import { ActionVerbAnalysis } from "../resume-analyse-types";

const removeActionVerbs = (
  text: string,
  actionVerbAnalysis: ActionVerbAnalysis[]
) => {
  return actionVerbAnalysis.filter((verbAnalysis) => {
    const regex = new RegExp(`\\b${verbAnalysis.verb}\\b`, "i");
    return regex.test(text);
  });
};

export { removeActionVerbs };
